import _mixin from '../_mixin'

export default {
  name: 'SVersionActivityNew',
  cnName: '固定版本活动(新)',
  type: 'activity_other',
  preview: 'https://rescdn.ssjj.cn/website/2024/05/17/1f251f33e8d30b965516cb67201f8eda.jpg',
  // 属性相关
  props: {
    part1Id: 'version-data-1',
    part2Id: 'version-data-2',
    part3Id: 'version-data-3',
    part4Id: 'version-data-4',
    part5Id: 'version-data-5',
    part6Id: 'version-data-6',
    part7Id: 'version-data-7',
    part8Id: 'version-data-8',
    part9Id: 'version-data-9',
    ruleId: '686f646ac631ecc3eac04037', // 抽奖规则
    luckyBagRuleId: '686f6552c631ecc3eac04038', // 福袋规则
    rechargeRuleId: '686f6823c631ecc3eac04039', // 充值规则
    mainHeight: '11542px',
    part1Top: '0px', // 活动1位置
    part1Obj: [
      {
        bgWidth: '1920px',
        bgHeight: '1600px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/1a713b33867c40a51791b13e8ac77dc7.jpg'
      }
    ],
    lotteryCost: 1,
    lotteryBtn: [
      {
        left: '1000px',
        bottom: '960px',
        btnWidth: '185px',
        btnHeight: '60px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/e079aad2e855b2bc653ac66d03993219.png'
      }
    ],
    lotteryTenBtn: [
      {
        left: '1210px',
        bottom: '960px',
        btnWidth: '186px',
        btnHeight: '56px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/243cefe965f986d03cd567e963841e96.png'
      }
    ],
    part1Btn: [
      {
        left: '221px',
        bottom: '581px',
        btnWidth: '306px',
        btnHeight: '75px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/49f526488681503764e29419a27303c9.png'
      }
    ],
    part1TextStyle: [
      {
        left: '1170px',
        top: '465px',
        fontSize: '26px',
        color: '#000000'
      }
    ],
    part1Rule: [
      {
        left: '1210px',
        bottom: '800px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/3196a4f675559785dd8c4352f011fa88.png'
      }
    ],
    part1Record: [
      {
        left: '1030px',
        bottom: '800px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/d916eed2340b54f712195e587533a559.png'
      }
    ],
    prat1ReciveGiftBox: [
      {
        width: '1555px',
        height: '50px',
        btnWidth: '165px',
        btnHeight: '50px',
        bottom: '100px',
        left: '184px'
      }
    ],
    prat1ReciveTextBox: [
      {
        width: '1555px',
        height: '50px',
        bottom: '355px',
        left: '184px',
        fontSize: '26px',
        color: '#FDD738'
      }
    ],

    part3Top: '1600px', // 活动3位置
    part3BtnsFirst: [
      {
        left: '440px',
        bottom: '100px'
      }
    ],
    part3BtnsOther: [
      {
        boxWidth: '850px',
        boxHeight: '429px',
        left: '918px',
        bottom: '73px'
      }
    ],

    part3Obj: [
      {
        bgWidth: '1920px',
        bgHeight: '1017px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/4b6956085f4a03d6d7e81ceb85d191c6.jpg',
        itemWidth: '165px',
        itemHeight: '50px'
      }
    ],
    part3Btn: [
      {
        btnWidth: '166px',
        btnHeight: '91px'
      }
    ],

    part4Top: '2617px', // 版本累登活动位置
    part4LoginCount: [
      {
        fontSize: '26px',
        color: '#000000',
        left: '1780px',
        bottom: '620px'
      }
    ],
    part4Btns: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        bgWidth: '1920px',
        bgHeight: '783px',
        boxWidth: '1580px',
        bottom: '80px',
        left: '166px',
        boxHeight: '60px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/d8390ded27618c5cefeb074875bcd4c1.jpg'
      }
    ],

    part5Top: '3400px', // 周末福利活动位置
    part5Btns: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        bgWidth: '1920px',
        bgHeight: '744px',
        boxWidth: '1580px',
        boxHeight: '60px',
        bottom: '150px',
        left: '166px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/e19dac6219b28c31ebe4f266564133d6.jpg'
      }
    ],

    part6Top: '4144px', // 任务赢货币活动位置
    part6Btns: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        DailyTaskWidth: '1210px',
        DailyTaskHeight: '50px',
        DailyTaskLeft: '487px',
        DailyTaskBottom: '620px',
        WeeklyTaskWidth: '950px',
        WeeklyTaskHeight: '50px',
        WeeklyTaskLeft: '732px',
        WeeklyTaskBottom: '350px',
        SpecialTaskWidth: '1195px',
        SpecialTaskHeight: '50px',
        SpecialTaskLeft: '500px',
        SpecialTaskBottom: '90px',
        bgWidth: '1920px',
        bgHeight: '1030px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/54283d8ea95406b6d2fe315c1d8f399c.jpg'
      }
    ],
    part6Text: [
      {
        DailyTaskWidth: '1060px',
        DailyTaskHeight: '40px',
        DailyTaskLeft: '630px',
        DailyTaskBottom: '690px',
        WeeklyTaskWidth: '840px',
        WeeklyTaskHeight: '40px',
        WeeklyTaskLeft: '850px',
        WeeklyTaskBottom: '430px',
        SpecialTaskWidth: '1110px',
        SpecialTaskHeight: '40px',
        SpecialTaskLeft: '588px',
        SpecialTaskBottom: '170px',
        color: '#FDD738',
        fontSize: '18px'
      }
    ],

    part7Top: '9569px', // 好友任务活动位置
    part7Obj: [
      {
        itemWidth: '175px',
        itemHeight: '44px',
        bgWidth: '1920px',
        bgHeight: '1141px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/d07fd88e48b5cdd84c0024d8250424cc.jpg',
        inviteSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/8f6947cf30b8bbaa45beb9272d2f003a.png',
        joinSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/12b52bbe2306a758f8c43f7e123485e8.png'
      }
    ],
    part7Btns: [
      {
        inviteWidth: '680px',
        inviteHeight: '50px',
        inviteLeft: '500px',
        inviteBottom: '670px',
        taskWidth: '166px',
        taskHeight: '530px',
        taskLeft: '1500px',
        taskBottom: '100px'
      }
    ],
    part7Text: [
      {
        fontSize: '26px',
        color: '#FDD738',
        inviteTextLeft: '1510px',
        inviteTextBottom: '678px'
      }
    ],
    part8Top: '10710px', // 新回活动位置
    part8Obj: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        bgWidth: '1920px',
        bgHeight: '832px',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/96f03d418fb3a979ac61cbf96b90d46c.jpg',
        left: '460px',
        bottom: '200px',
        boxWidth: '1000px',
        boxHeight: '60px'
      }
    ],
    // ===== 活动 ID 配置 =====
    // 抽奖：GBEQB47DMRGJAXFUDRXAJ64PS4
    // 点券购买：ZMERCTKBZETKUQYQDZ2OW3RNTI
    // 累计抽奖：5VHHMT4E7TRM4BAZCHGAVZ4KXI
    // 签到：LEONEAB6YTRLYP3FIPFI62RF64
    // 累登：5KI3D4D2UC4ZPBDE2A663YN6A4
    // 周末福利：5SWPSJE72SCN6KQHCELZJKAE3M
    // 周期任务：5PHDCQNKOPXPPZVG53BN2T3XZQ
    // 组队任务：4YKTZPG7SBGMRAQIWWY2VPYLWQ
    // 新回活动：D7F6AQREX2GQMYV4HZM26AZ7FY

    part9Top: '5174px', // 开箱活动位置
    part9Box: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/4e14e985c416c212c9353e0d03c1459f.jpg',
      style: {
        width: '1920px',
        height: '2117px'
      }
    },
    part9BtnConfig: [
      {
        itemWidth: '166px',
        itemHeight: '50px',
        processTextColor: '#fff',
        processTextFontSize: '26px'
      }
    ],
    part9Position: [
      {
        top: '1650px',
        left: '740px',
        process_top: '1660px',
        process_left: '475px',
        name: '每日任务'
      },
      {
        top: '1650px',
        left: '1570px',
        process_top: '1660px',
        process_left: '1330px',
        name: '每周任务'
      },
      {
        top: '1890px',
        left: '1020px',
        process_top: '1900px',
        process_left: '700px',
        name: '特别任务'
      }
    ],
    part9LuckyBag: [
      {
        src: 'https://rescdn.ssjj.cn/website/2025/07/09/37e8c87520675fe9af4407fad283950d.png',
        itemWidth: '424px',
        itemHeight: '97px',
        top: '1260px',
        left: '500px',
        count: 1,
        name: '一次福袋'
      },
      {
        src: 'https://rescdn.ssjj.cn/website/2025/07/09/4c079f8c9fc70d3a869a07005368c2f8.png',
        itemWidth: '424px',
        itemHeight: '97px',
        top: '1260px',
        left: '980px',
        count: 5,
        name: '五次福袋'
      }
    ],
    part9Rule: [
      {
        left: '1518px',
        top: '1417px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/10/139a0b8b649d94c6eacf7d485d44ae12.png'
      }
    ],
    part9Reocrd: [
      {
        left: '1700px',
        top: '1417px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/10/eef71da928dc54303add67c647a4e60f.png'
      }
    ],
    part9LuckyBagInfo: [
      {
        top: '1421px',
        left: '1440px',
        color: '#fff',
        fontSize: '26px'
      }
    ],
    part10Top: '7291px',
    keyword: 'test_keyword',
    rankRule: [
      {
        left: '1340px',
        top: '450px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/10/139a0b8b649d94c6eacf7d485d44ae12.png'
      }
    ],
    rankReocrd: [
      {
        left: '1155px',
        top: '450px',
        btnWidth: '156px',
        btnHeight: '40px',
        btnSrc: 'https://rescdn.ssjj.cn/website/2025/07/10/5be1a3fde5428edd9ebb0696f2840118.png'
      }
    ],
    rankObj: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/ee26ab88618cd4dc80f01bb5d2b998ab.jpg',
      style: {
        width: '1920px',
        height: '2278px'
      }
    },
    rankPositionConfig: [
      {
        name: '第一名',
        top: '1016px',
        left: '861px',
        width: '200px',
        height: '80px',
        name_color: '#fff',
        name_fontSize: '26px',
        coin_color: '#faeaa9',
        coin_fontSize: '26px'
      },
      {
        name: '第二名',
        top: '1135px',
        left: '433px',
        width: '200px',
        height: '80px',
        name_color: '#fff',
        name_fontSize: '26px',
        coin_color: '#faeaa9',
        coin_fontSize: '26px'
      },
      {
        name: '第三名',
        top: '1135px',
        left: '1288px',
        width: '200px',
        height: '80px',
        name_color: '#fff',
        name_fontSize: '26px',
        coin_color: '#faeaa9',
        coin_fontSize: '26px'
      }
    ],
    rankOtherConfig: [
      {
        width: '875px',
        top: '1728px',
        left: '506px',
        color: '#fff',
        fontSize: '24px',
        itemHeight: '60px'
      }
    ],
    rankUserConfig: [
      {
        top: '321px',
        left: '678px',
        width: '700px',
        height: '80px',
        itemWidth: '150px',
        color: '#fff',
        fontSize: '26px'
      }
    ],

    activityId1: '7L2E7R27IK2ROJGFYC5Y7HTADI', // 抽奖
    activityId2: 'KXPDZ6PW2ZZUHP2L47H7A3EBR4', // 点券购买
    activityId3: 'N3QKNXEELEPZEIUXHK32NAZIAU', // 累计抽奖
    activityId4: 'URIN634ASAZT3JSN7YWWJIMYAA', // 签到
    activityId5: 'JGVZFM6ANGTIDX4LCQUNRJLVHU', // 累登
    activityId6: 'FQ3YM66G27OSCVLKFYX56NRXME', // 周末福利
    activityId7: 'X6RGF434WNMY5OILEW4YHCWEUM', // 周期任务
    activityId8: 'LG4LKO7NPTR3LPWGGPN4AFCOOY', // 组队任务
    activityId9: 'T5MZF6XCXD2CUMYIMW7YXUCOS4', // 新回活动
    activityId11: 'GSULEG2PO4VZ7KDOFELW5E7DE4', // 福袋任务
    activityId12: '2SDOVJXJWV4SEMZAY7525N3T5I', // 抽福袋
    // ===== text color =====
    textColorLevel1: '#fff',
    textColorLevel2: '#fff',
    textColorLevel3: '#999',
    textColorActive: '#C3636B',
    miniBtnColor: '#EA0037',

    // ===== 领取按钮 =====
    // 未开始按钮
    receiveBtn0: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/a70cbd29349310e89327fb2d35f7313c.png'
    },
    // 未完成按钮
    receiveBtn1: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/11/c4964a1da6641f9130be19a517f42e29.png'
    },
    // 领取按钮
    receiveBtn2: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/e6fc08651ce1513f0f4c3485624085b2.png'
    },
    // 已领取按钮
    receiveBtn3: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/18b780c714a960c2eb3081cbf44cc22d.png'
    },
    // 已过期按钮
    receiveBtn4: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/87b11d2d30b4235f936d250d7341ec0f.png'
    },
    // ===== 抽奖按钮 =====
    // drawActiveItem: '1,2',
    drawBgColor: '#C4CCE6,#E8E9EC',
    drawBgColorActive: '#FFBE57,#FFE8BB',

    // ====== 侧边栏 ======
    textColor: '#000',
    textHoverColor: '#fff',
    sideBarNavShowDistance: '1000',
    sideBarNavText: [
      {
        id: 'version-data-1',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/3d5bdac710c894121003d75e11bf1bc5.png'
      },
      {
        id: 'version-data-2',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/f94c16c5a83de2e07acbeb84707f1ecc.png'
      },
      {
        id: 'version-data-3',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/72274e53fb8d311aaea6cc82aa13159d.png'
      },
      {
        id: 'version-data-4',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/ce43a2f2361443e154d8fdc8ab9f6548.png'
      },
      {
        id: 'version-data-5',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/6584fe4f38b2e7dfa03357c32c49b707.png'
      },
      {
        id: 'version-data-6',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/2477cb2abdd950fa8509e996e3f44ff0.png'
      },
      {
        id: 'version-data-7',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/439428aee651ef6dc329966fca6ab2af.png'
      },
      {
        id: 'version-data-8',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/1bc00bcfdc16342c63c6af8f9229148a.png'
      },
      {
        id: 'version-data-9',
        bgSrc: 'https://rescdn.ssjj.cn/website/2025/07/11/bd1838208db92fbf7fda889b41b89fc6.png'
      }
    ],
    sliderBox: [
      {
        boxWidth: '1800px',
        itemHeight: '98px',
        itemWidth: '341px'
      }
    ],
    sliderTop: '5%',

    // 弹窗相关
    modalBg: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/2b99969f2797529d17b473770e4006cf.jpg',
      style: {
        width: '750px',
        height: '650px'
      }
    },
    modalCloseIcon: {
      src: 'https://rescdn.ssjj.cn/website/2025/07/10/e2bb54259012ce0658f325d0ccd9bbda.png',
      style: {
        width: '54px',
        height: '54px',
        right: '-60px',
        top: '0px'
      }
    },
    modalTitleStyle: '{"color": "#A81548", "opacity": "0.8", "font-weight": "700"}',
    modalTextStyle: '{"color": "#ffffff"}',
    modalConfirmBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/03/15/99b4684fb700b34aa5da97b1024be328.png)","color": "#FFF", "font-weight": "700"}',
    modalCancelBtnStyle: '{"background-image":"url(https://rescdn.ssjj.cn/website/2024/03/15/b4c489022fc32a83793352f2e4d29c78.png)","color": "#FFF", "font-weight": "700"}'
  },
  propsDesc: [
    // 公共 配置 start
    {
      target: '=== 公共 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part1Id',
      label: '转盘活动锚点'
    },
    {
      target: 'part2Id',
      label: '签到活动锚点'
    },
    {
      target: 'part3Id',
      label: '累登活动锚点'
    },
    {
      target: 'part4Id',
      label: '周末福利活动锚点'
    },
    {
      target: 'part5Id',
      label: '周期任务活动锚点'
    },
    {
      target: 'part6Id',
      label: '开箱活动锚点'
    },
    {
      target: 'part7Id',
      label: '排行榜锚点'
    },
    {
      target: 'part8Id',
      label: '组队任务活动锚点'
    },
    {
      target: 'part9Id',
      label: '新回活动锚点'
    },
    {
      target: 'sliderTop',
      label: '导航容器距离顶部距离'
    },
    {
      target: 'sliderBox',
      label: '导航容器',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'boxWidth'
        },
        {
          title: '图片宽度',
          target: 'itemWidth'
        },
        {
          title: '图片高度',
          target: 'itemHeight'
        }
      ]
    },
    {
      target: 'sideBarNavText',
      label: '导航文本',
      formType: 'list',
      listConfig: [
        {
          title: '图片src',
          src: 'https://rescdn.ssjj.cn/website/2025/03/20/6f81031f605f1d3820b5df766bd0ef2b.png',
          target: 'bgSrc'
        },
        {
          title: '锚点ID',
          target: 'id'
        }
      ]
    },
    {
      target: 'sideBarNavShowDistance',
      label: '侧边栏显示距离'
    },
    {
      target: 'ruleId',
      label: '抽奖规则ID'
    },
    {
      target: 'luckyBagRuleId',
      label: '福袋规则ID'
    },
    {
      target: 'rechargeRuleId',
      label: '充值规则ID'
    },
    // '=== 公共 配置 end ===
    {
      target: '=== 公共 配置 end ===',
      formType: 'divider'
    },
    // 抽奖 配置 start
    {
      target: '=== 抽奖 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part1Top',
      label: '转盘活动定位'
    },
    {
      target: 'lotteryCost',
      label: '抽奖消耗'
    },
    {
      target: 'part1Obj',
      label: '抽奖活动配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'bgWidth'
        },
        {
          title: '图片高度',
          target: 'bgHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part1Btn',
      label: '货币购买',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'part1Rule',
      label: '抽奖规则',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'part1TextStyle',
      label: '货币余额样式',
      formType: 'list',
      listConfig: [
        {
          title: '文字大小',
          target: 'fontSize'
        },
        {
          title: '文字颜色',
          target: 'color'
        },
        {
          title: '文字位置left',
          target: 'left'
        },
        {
          title: '文字位置top',
          target: 'top'
        }
      ]
    },
    {
      target: 'part1Record',
      label: '领取记录',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'prat1ReciveGiftBox',
      label: '领取累计容器',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'width'
        },
        {
          title: '容器高度',
          target: 'height'
        },
        {
          title: '领取按钮高度',
          target: 'btnHeight'
        },
        {
          title: '领取按钮宽度',
          target: 'btnWidth'
        },
        {
          title: '容器位置left',
          target: 'left'
        },
        {
          title: '容器位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'prat1ReciveTextBox',
      label: '领取累计文本容器',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'width'
        },
        {
          title: '容器高度',
          target: 'height'
        },
        {
          title: '容器位置left',
          target: 'left'
        },
        {
          title: '容器位置bottom',
          target: 'bottom'
        },
        {
          title: '文字大小',
          target: 'fontSize'
        },
        {
          title: '文字颜色',
          target: 'color'
        }
      ]
    },
    {
      target: 'lotteryBtn',
      label: '抽一次按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'lotteryTenBtn',
      label: '抽10次按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    // === 抽奖 配置 end ===
    {
      target: '=== 抽奖 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 签到领取 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part3Top',
      label: '武器直购活动定位'
    },
    {
      target: 'part3Obj',
      label: '签到领取活动配置',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'bgWidth'
        },
        {
          title: '图片高度',
          target: 'bgHeight'
        },
        {
          title: '图片背景链接',
          target: 'bgSrc'
        },
        {
          title: '签到按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '签到按钮高度',
          target: 'itemHeight'
        }
      ]
    },
    {
      target: 'part3BtnsFirst',
      label: '签到领取活动配置-第一个',
      formType: 'list',
      listConfig: [
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: 'part3BtnsOther',
      label: '签到领取活动容器配置-剩余部分',
      formType: 'list',
      listConfig: [
        {
          title: '容器宽度',
          target: 'boxWidth'
        },
        {
          title: '容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: '=== 签到领取 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 版本累登 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part4Top',
      label: '版本累登活动定位'
    },
    {
      target: 'part4Btns',
      label: '版本累登活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '按钮容器宽度',
          target: 'boxWidth'
        },
        {
          title: '按钮容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part4LoginCount',
      label: '版本累登活动登录次数',
      formType: 'list',
      listConfig: [
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        },
        {
          title: '字体大小',
          target: 'fontSize'
        },
        {
          title: '字体颜色',
          target: 'color'
        }
      ]
    },
    {
      target: '=== 版本累登 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 周末福利 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part5Top',
      label: '周末福利活动定位'
    },
    {
      target: 'part5Btns',
      label: '周末福利活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '按钮容器宽度',
          target: 'boxWidth'
        },
        {
          title: '按钮容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: '=== 周末福利 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 任务赢货币 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part6Top',
      label: '任务赢货币活动定位'
    },
    {
      target: 'part6Btns',
      label: '任务赢货币活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '每日任务容器宽度',
          target: 'DailyTaskWidth'
        },
        {
          title: '每日任务容器高度',
          target: 'DailyTaskHeight'
        },
        {
          title: '每日任务容器位置left',
          target: 'DailyTaskLeft'
        },
        {
          title: '每日任务容器位置bottom',
          target: 'DailyTaskBottom'
        },
        {
          title: '每周任务容器宽度',
          target: 'WeeklyTaskWidth'
        },
        {
          title: '每周任务高度',
          target: 'WeeklyTaskHeight'
        },
        {
          title: '每周任务容器位置left',
          target: 'WeeklyTaskLeft'
        },
        {
          title: '每周任务容器位置bottom',
          target: 'WeeklyTaskBottom'
        },
        {
          title: '特殊任务容器宽度',
          target: 'SpecialTaskWidth'
        },
        {
          title: '特殊任务高度',
          target: 'SpecialTaskHeight'
        },
        {
          title: '特殊任务容器位置left',
          target: 'SpecialTaskLeft'
        },
        {
          title: '特殊任务容器位置bottom',
          target: 'SpecialTaskBottom'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part6Text',
      label: '任务赢货币活动文本',
      formType: 'list',
      listConfig: [
        {
          title: '每日任务容器宽度',
          target: 'DailyTaskWidth'
        },
        {
          title: '每日任务容器高度',
          target: 'DailyTaskHeight'
        },
        {
          title: '每日任务容器位置left',
          target: 'DailyTaskLeft'
        },
        {
          title: '每日任务容器位置bottom',
          target: 'DailyTaskBottom'
        },
        {
          title: '每周任务容器宽度',
          target: 'WeeklyTaskWidth'
        },
        {
          title: '每周任务高度',
          target: 'WeeklyTaskHeight'
        },
        {
          title: '每周任务容器位置left',
          target: 'WeeklyTaskLeft'
        },
        {
          title: '每周任务容器位置bottom',
          target: 'WeeklyTaskBottom'
        },
        {
          title: '特殊任务容器宽度',
          target: 'SpecialTaskWidth'
        },
        {
          title: '特殊任务高度',
          target: 'SpecialTaskHeight'
        },
        {
          title: '特殊任务容器位置left',
          target: 'SpecialTaskLeft'
        },
        {
          title: '特殊任务容器位置bottom',
          target: 'SpecialTaskBottom'
        },
        {
          title: '文本颜色',
          target: 'color'
        },
        {
          title: '文本大小',
          target: 'fontSize'
        }
      ]
    },
    {
      target: '=== 任务赢货币 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 好友任务 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part7Top',
      label: '好友任务活动定位'
    },
    {
      target: 'part7Obj',
      label: '好友任务活动对象',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '容器宽度',
          target: 'bgWidth'
        },
        {
          title: '容器高度',
          target: 'bgHeight'
        },
        {
          title: '邀请按钮',
          target: 'inviteSrc'
        },
        {
          title: '加入按钮',
          target: 'joinSrc'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        }
      ]
    },
    {
      target: 'part7Btns',
      label: '好友任务活动按钮',
      formType: 'list',
      listConfig: [
        {
          title: '邀请容器宽度',
          target: 'inviteWidth'
        },
        {
          title: '邀请容器高度',
          target: 'inviteHeight'
        },
        {
          title: '邀请容器位置left',
          target: 'inviteLeft'
        },
        {
          title: '邀请容器位置bottom',
          target: 'inviteBottom'
        },
        {
          title: '任务容器宽度',
          target: 'taskWidth'
        },
        {
          title: '任务容器高度',
          target: 'taskHeight'
        },
        {
          title: '任务容器位置left',
          target: 'taskLeft'
        },
        {
          title: '任务容器位置bottom',
          target: 'taskBottom'
        }
      ]
    },
    {
      target: 'part7Text',
      label: '好友任务活动文本',
      formType: 'list',
      listConfig: [
        {
          title: '字体大小',
          target: 'fontSize'
        },
        {
          title: '文本颜色',
          target: 'color'
        },
        {
          title: '文字位置left',
          target: 'inviteTextLeft'
        },
        {
          title: '文字位置bottom',
          target: 'inviteTextBottom'
        }
      ]
    },
    {
      target: '=== 好友任务 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 新回活动 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part8Top',
      label: '新回活动定位'
    },
    {
      target: 'part8Obj',
      label: '新回活动对象',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '背景宽度',
          target: 'bgWidth'
        },
        {
          title: '背景高度',
          target: 'bgHeight'
        },
        {
          title: '容器宽度',
          target: 'boxWidth'
        },
        {
          title: '容器高度',
          target: 'boxHeight'
        },
        {
          title: '按钮容器背景',
          target: 'bgSrc'
        },
        {
          title: '按钮容器位置left',
          target: 'left'
        },
        {
          title: '按钮容器位置bottom',
          target: 'bottom'
        }
      ]
    },
    {
      target: '=== 新回活动 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 开箱活动 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part9Top',
      label: '开箱活动定位'
    },
    {
      target: 'part9Rule',
      label: '开箱活动-规则按钮',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置top',
          target: 'top'
        }
      ]
    },
    {
      target: 'part9Reocrd',
      label: '开箱活动-记录按钮',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置top',
          target: 'top'
        }
      ]
    },
    {
      target: 'part9Box',
      label: '开箱活动背景图',
      formType: 'image'
    },
    {
      target: 'part9BtnConfig',
      label: '开箱活动-按钮配置',
      formType: 'list',
      listConfig: [
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '进度条文本颜色',
          target: 'processTextColor'
        },
        {
          title: '进度条文本大小',
          target: 'processTextFontSize'
        }
      ]
    },
    {
      target: 'part9Position',
      label: '开箱活动-任务领取配置',
      formType: 'list',
      listConfig: [
        {
          title: '按钮位置top',
          target: 'top'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '进度位置top',
          target: 'process_top'
        },
        {
          title: '进度位置left',
          target: 'process_left'
        },
        {
          title: '任务名称',
          target: 'name'
        }
      ]
    },
    {
      target: 'part9LuckyBag',
      label: '开箱活动-抽福袋配置',
      formType: 'list',
      listConfig: [
        {
          title: '按钮位置top',
          target: 'top'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '抽奖次数',
          target: 'count'
        },
        {
          title: '按钮宽度',
          target: 'itemWidth'
        },
        {
          title: '按钮高度',
          target: 'itemHeight'
        },
        {
          title: '按钮图',
          target: 'src'
        }
      ]
    },
    {
      target: 'part9LuckyBagInfo',
      label: '开箱活动-抽福袋次数信息',
      formType: 'list',
      listConfig: [
        {
          title: '次数信息位置top',
          target: 'top'
        },
        {
          title: '次数信息位置left',
          target: 'left'
        },
        {
          title: '文本颜色',
          target: 'color'
        },
        {
          title: '文本大小',
          target: 'fontSize'
        }
      ]
    },
    {
      target: '=== 开箱活动 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 排行榜 配置 start ===',
      formType: 'divider'
    },
    {
      target: 'part10Top',
      label: '排行榜定位'
    },
    {
      target: 'keyword',
      label: '开箱活动-搜索关键词'
    },
    {
      target: 'rankRule',
      label: '排行榜-规则按钮',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置top',
          target: 'top'
        }
      ]
    },
    {
      target: 'rankReocrd',
      label: '排行榜-填写地址',
      formType: 'list',
      listConfig: [
        {
          title: '图片宽度',
          target: 'btnWidth'
        },
        {
          title: '图片高度',
          target: 'btnHeight'
        },
        {
          title: '图片背景链接',
          target: 'btnSrc'
        },
        {
          title: '按钮位置left',
          target: 'left'
        },
        {
          title: '按钮位置top',
          target: 'top'
        }
      ]
    },
    {
      target: 'rankObj',
      label: '排行榜背景图',
      formType: 'image'
    },
    {
      target: 'rankPositionConfig',
      label: '排行榜前三名位置配置',
      formType: 'list',
      listConfig: [
        {
          title: '位置名称',
          target: 'name'
        },
        {
          title: '容器宽度',
          target: 'width'
        },
        {
          title: '容器高度',
          target: 'height'
        },
        {
          title: '排行榜位置top',
          target: 'top'
        },
        {
          title: '排行榜位置left',
          target: 'left'
        },
        {
          title: '排行榜名称颜色',
          target: 'name_color'
        },
        {
          title: '排行榜名称大小',
          target: 'name_fontSize'
        },
        {
          title: '排行榜金币颜色',
          target: 'coin_color'
        },
        {
          title: '排行榜金币大小',
          target: 'coin_fontSize'
        }
      ]
    },
    {
      target: 'rankOtherConfig',
      label: '排行榜其余位置配置',
      formType: 'list',
      listConfig: [
        {
          title: '排行榜位置top',
          target: 'top'
        },
        {
          title: '排行榜位置left',
          target: 'left'
        },
        {
          title: '排行榜宽度',
          target: 'width'
        },
        {
          title: '排行榜文本颜色',
          target: 'color'
        },
        {
          title: '排行榜文本大小',
          target: 'fontSize'
        },
        {
          title: '排行榜每项高度',
          target: 'itemHeight'
        }
      ]
    },
    {
      target: 'rankUserConfig',
      label: '排行榜用户信息配置',
      formType: 'list',
      listConfig: [
        {
          title: '用户信息位置top',
          target: 'top'
        },
        {
          title: '用户信息位置left',
          target: 'left'
        },
        {
          title: '用户信息容器宽度',
          target: 'width'
        },
        {
          title: '用户信息容器高度',
          target: 'height'
        },
        {
          title: '用户信息宽度',
          target: 'itemWidth'
        },
        {
          title: '用户信息高度',
          target: 'itemHeight'
        },
        {
          title: '用户信息文本颜色',
          target: 'color'
        },
        {
          title: '用户信息文本大小',
          target: 'fontSize'
        }
      ]
    },
    {
      target: '=== 排行榜 配置 end ===',
      formType: 'divider'
    },
    {
      target: '=== 活动 ID 配置 ===',
      formType: 'divider'
    },
    {
      target: 'activityId1',
      label: '抽奖活动ID'
    },
    {
      target: 'activityId2',
      label: '探险币购买活动ID'
    },
    {
      target: 'activityId3',
      label: '累计抽奖活动ID'
    },
    {
      target: 'activityId4',
      label: '签到活动ID'
    },
    {
      target: 'activityId5',
      label: '累登活动ID'
    },
    {
      target: 'activityId6',
      label: '周末福利活动ID'
    },
    {
      target: 'activityId7',
      label: '周期任务活动ID'
    },
    {
      target: 'activityId8',
      label: '组队任务活动ID'
    },
    {
      target: 'activityId9',
      label: '新回活动ID'
    },
    {
      target: '公共文本颜色',
      formType: 'divider'
    },
    {
      target: 'textColorLevel1',
      label: '一级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorLevel2',
      label: '二级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorLevel3',
      label: '三级文本颜色',
      formType: 'color'
    },
    {
      target: 'textColorActive',
      label: '活跃文本颜色',
      formType: 'color'
    },
    {
      target: 'miniBtnColor',
      label: '小按钮颜色',
      formType: 'color'
    },

    {
      target: '---补给商店列表---',
      formType: 'divider'
    },
    {
      target: 'shopList',
      label: '购买物品列表',
      formType: 'list',
      listConfig: [
        {
          title: '物品图',
          target: 'awardImg'
        },
        {
          title: '按钮图',
          target: 'btnImg'
        }
      ]
    },
    {
      target: '--抽奖相关--',
      formType: 'divider'
    },
    // {
    //   target: 'drawActiveItem',
    //   label: '高亮显示项'
    // },
    {
      target: 'drawBgColor',
      label: '默认背景过渡色'
    },
    {
      target: 'drawBgColorActive',
      label: '高亮背景过渡色'
    },
    {
      target: '-----领取按钮-----',
      formType: 'divider'
    },
    {
      target: 'receiveBtn0',
      label: '未开始按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn1',
      label: '未完成按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn2',
      label: '领取按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn3',
      label: '已领取按钮',
      formType: 'image'
    },
    {
      target: 'receiveBtn4',
      label: '已过期按钮',
      formType: 'image'
    },
    {
      target: 'textColor',
      label: '侧边栏默认色值',
      formType: 'color'
    },
    {
      target: 'textHoverColor',
      label: '侧边栏选中色值',
      formType: 'color'
    },
    {
      target: '===== 公共弹窗 ======',
      formType: 'divider'
    },
    {
      target: 'modalBg',
      label: '弹窗背景图',
      formType: 'image'
    },
    {
      target: 'modalCloseIcon',
      label: '关闭按钮',
      formType: 'image'
    },
    {
      target: 'modalTitleStyle',
      label: '标题样式',
      formType: 'textarea'
    },
    {
      target: 'modalTextStyle',
      label: '文本样式',
      formType: 'textarea'
    },
    {
      target: 'modalConfirmBtnStyle',
      label: '确认按钮样式',
      formType: 'textarea'
    },
    {
      target: 'modalCancelBtnStyle',
      label: '取消按钮样式',
      formType: 'textarea'
    },
    {
      target: 'mainHeight',
      label: '主体高度'
    }
  ],

  // 样式相关
  styles: {
    ..._mixin.styles
  },
  stylesDesc: [
    ..._mixin.stylesDesc
  ],

  // 事件相关
  events: {
    // click: () => {} 无需配置
  },
  eventsList: [
    // eventTpl 无需配置
  ],
  eventsDesc: [
    ..._mixin.eventsDesc
  ],

  methods: [
    ..._mixin.methods
  ],
  children: [
    // {
    //   id: genId() + '_BaseGroup_0',
    //   ...BaseGroup
    // },
    // {
    //   id: genId() + '_BaseGroup_1',
    //   ...BaseGroup
    // }
  ]
}
